import { FinancialJuiceWidget } from './FinancialJuiceWidget';

interface TickstrikeWidgetProps {
  onRemove: () => void;
}

export function TickstrikeWidget({ onRemove }: TickstrikeWidgetProps) {
  return (
    <FinancialJuiceWidget
      widgetType="TS"
      mode="inline"
      title="Tickstrike"
      onRemove={onRemove}
    />
  );
}
